import type { Translations } from './mergeTranslations';

type TaxType = 'VAT' | 'GST';

export const getTaxType = (currencyCode?: Translations['currencyCode']): TaxType => {
  if (currencyCode === 'EUR' || currencyCode === 'GBP') return 'VAT';

  return 'GST';
};
